<section class="buy-now-section">
  <div class="buy-now-shell">

    <a routerLink="/pricing" class="back-link">&larr; Back to pricing</a>

    <div class="buy-now-grid">

      <!-- Order summary -->
      <div class="summary-card">
        <span class="summary-label">You're purchasing</span>
        <h2 class="summary-plan">{{ plan.name }} Plan</h2>
        <div class="summary-price">
          <span class="summary-amount">{{ amount }}</span>
          <span class="summary-currency">PKR</span>
          <span class="summary-period">{{ period }}</span>
        </div>
        <ul class="summary-features">
          <li *ngFor="let feature of plan.features">{{ feature }}</li>
        </ul>
        <p class="summary-note">
          No online payment yet &mdash; submit your details and our sales team will confirm your order
          and set up billing on WhatsApp.
        </p>
      </div>

      <!-- Buyer form -->
      <div class="form-card" *ngIf="!sent; else sentBlock">
        <h1 class="form-title">Confirm your details</h1>
        <form (ngSubmit)="onSubmit()" novalidate>
          <div class="form-field">
            <label for="companyName">Company name</label>
            <input id="companyName" name="companyName" type="text" [(ngModel)]="companyName" required />
            <span class="field-error" *ngIf="formSubmitted && !companyName">Company name is required.</span>
          </div>

          <div class="form-field">
            <label for="contactPerson">Contact person</label>
            <input id="contactPerson" name="contactPerson" type="text" [(ngModel)]="contactPerson" required />
            <span class="field-error" *ngIf="formSubmitted && !contactPerson">Contact person is required.</span>
          </div>

          <div class="form-field">
            <label for="email">Email</label>
            <input id="email" name="email" type="email" [(ngModel)]="email" required />
            <span class="field-error" *ngIf="formSubmitted && !email">Email is required.</span>
          </div>

          <div class="form-field">
            <label for="phone">Phone</label>
            <input id="phone" name="phone" type="tel" [(ngModel)]="phone" required />
            <span class="field-error" *ngIf="formSubmitted && !phone">Phone is required.</span>
          </div>

          <div class="form-field">
            <label for="notes">Notes <span class="optional">(optional)</span></label>
            <textarea id="notes" name="notes" rows="3" [(ngModel)]="notes"></textarea>
          </div>

          <button type="submit" class="submit-btn">
            <i class="fab fa-whatsapp"></i>
            Continue on WhatsApp
          </button>
        </form>
      </div>

      <ng-template #sentBlock>
        <div class="form-card sent-card">
          <i class="fab fa-whatsapp sent-icon"></i>
          <h2>WhatsApp Opened</h2>
          <p>
            If a new tab didn't open automatically,
            <a [href]="whatsappUrl" target="_blank" rel="noopener noreferrer">click here</a>
            to chat with our sales team.
          </p>
          <a routerLink="/pricing" class="submit-btn secondary-btn">
            <i class="fas fa-arrow-left"></i>
            Back to Pricing
          </a>
        </div>
      </ng-template>

    </div>
  </div>
</section>
